import { render } from "./PlayConnect.vue?vue&type=template&id=c1a89cf0&scoped=true"
import script from "./PlayConnect.vue?vue&type=script&lang=js"
export * from "./PlayConnect.vue?vue&type=script&lang=js"

import "./PlayConnect.vue?vue&type=style&index=0&id=c1a89cf0&scoped=true&lang=css"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a89cf0"]])

export default __exports__